export default {
  key: { id: 'key' },
  title: { id: 'title' },
  description: { id: 'description' },
  edit: { id: 'edit' },
  save: { id: 'save' },
  actions: { id: 'actions' },
}
